export enum ScoreName {
  ALL = 'All Score Components',
  Math = 'Math',
  EBRW = 'Reading & Writing'
}
